import { FC, useCallback, useState } from 'react';
import { Icon, Input } from '@components';
import { ColorsEnum } from '@utilities/enums';

interface Props {
    toggleMenu: () => void;
    onDrawerToggle?: () => void;
    onCustomMenuButtonPress?: () => void;
    onGoBack?: () => void;
    onSearchChange?: (search: string) => void;
}

export const Header: FC<Props> = ({ 
    toggleMenu, 
    onDrawerToggle, 
    onCustomMenuButtonPress, 
    onSearchChange, 
    onGoBack,
}) => {
    
    const [showSearch, setShowSearch] = useState<boolean>(false);
    const [search, setSearch] = useState<string>('');

    const handleSearchChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setSearch(value);
        onSearchChange?.(value);
    }, [onSearchChange]);

    const handleSearchClick = useCallback(() => {
        setShowSearch(!showSearch);
        setSearch('')
        onSearchChange?.('')
    }, [showSearch, onSearchChange]);

    return (
        <div className="navbar bg-base-100 shadow-sm">
            <div
                className={`
                    navbar-start flex items-center 
                    ${showSearch ? 'hidden md:flex' : ''}
                    `}
            >

                <div
                    tabIndex={0}
                    role="button"
                    className="hidden lg:block btn btn-ghost btn-circle lg:hidden"
                    onClick={toggleMenu}
                >
                    <Icon iconName="Menu" color={ColorsEnum.PRIMARY} />
                </div>
                {
                    !!onGoBack && (
                        <div className=' mr-4'>
                            <Icon
                                onPress={onGoBack}
                                iconName="CircleChevronLeft"
                                size={25}
                                color={ColorsEnum.PRIMARY}
                            />
                        </div>
                    )
                }
                <Icon
                    iconName="Bell"
                    color={ColorsEnum.SECONDARY}
                />
            </div>

            <div
                className="navbar-end flex items-center flex-grow"
            >

                {
                    showSearch && !!onSearchChange && (
                        <div className="flex-1 w-full mr-0 md:mr-2">
                            <Input
                                value={search}
                                autoFocus
                                type="text"
                                placeholder="Recherche"
                                className="input input-bordered rounded-full w-full"
                                rightIcon={
                                    <Icon
                                        iconName="CircleX"
                                        size={25}
                                        onPress={handleSearchClick}
                                        color={ColorsEnum.PRIMARY}
                                    />
                                }
                                onChange={handleSearchChange}
                            />
                        </div>
                    )
                }

                {
                    !showSearch && !!onSearchChange && (
                        <button
                            className="btn btn-ghost btn-circle"
                            onClick={handleSearchClick}
                        >
                            <Icon iconName="Search"
                                color={ColorsEnum.PRIMARY}
                            />
                        </button>
                    )
                }

                {
                    !!onDrawerToggle && (
                        <label
                            onClick={onDrawerToggle}
                            htmlFor="my-drawer-4"
                            className={`
                                btn btn-secondary p-2 rounded-full
                                cursor-pointer  ${showSearch ? 'hidden md:flex' : ''}
                                `}
                        >
                            <Icon iconName="ChartBarStacked" />
                        </label>
                    )
                }
                {
                    !!onCustomMenuButtonPress && (
                        <label
                            onClick={onCustomMenuButtonPress}
                            htmlFor="my-drawer-4"
                            className={`md:hidden 
                         btn btn-secondary p-2 rounded-full
                         cursor-pointer  ${showSearch ? 'hidden md:flex' : ''}
                         `}
                        >
                            <Icon iconName="PanelsTopLeft" />
                        </label>
                    )
                }
            </div>
        </div>
    );
};
